// extracted by mini-css-extract-plugin
export default {"page":"PdfViewer_page__6uDce","modalPop":"PdfViewer_modalPop__g9Spb"};